'use client';

import { useEffect } from 'react';

import { useAuthStore } from '@/stores/authStore';

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

export function GoogleAnalyticsUserBinding() {
  const user = useAuthStore((state) => state.user);
  const userId = user?.user?.id ?? null;
  const accessibleApp = user?.accessible_app ?? null;
  const primaryOrganisationId = user?.organisations?.[0]?.id ?? null;

  useEffect(() => {
    if (typeof window === 'undefined' || !window.gtag) return;

    if (process.env.NODE_ENV !== 'production') return;

    // Only set user_id if it exists
    if (userId != null) {
      window.gtag('set', {
        user_id: String(userId),
      });
    }

    window.gtag('set', 'user_properties', {
      user_accessible_app: accessibleApp,
      user_organisation_id: primaryOrganisationId,
    });
  }, [userId, accessibleApp, primaryOrganisationId]);

  return null;
}
